import { Pipe, PipeTransform } from '@angular/core';
import { ParseInvoiceError } from '@marmon/shared/types/analysis';

@Pipe({
	standalone: true,
	name: 'invoiceError',
})
export class InvoiceErrorPipe implements PipeTransform {
	transform(value: ParseInvoiceError): { title: string; subtitle: string } {
		const messages = [];
		// +1 to made the index human-readable
		if (value.row) messages.push(`Row ${value.row + 1}`);
		if (value.index) messages.push(`Column index ${value.index}`);

		return {
			title: value.messageHtml ?? value.message,
			subtitle: messages.join(', '),
		};
	}
}
